import { api } from "@/api";

export const deleteMatchEvent = async (
  matchId: string,
  eventId: number
): Promise<void> => {
  await api.client.delete(`/matches/${matchId}/events/${eventId}`);
};

export const deleteAllMatchEvents = async (matchId: string): Promise<void> => {
  await api.client.delete(`/matches/${matchId}/events`);
};
